export default {
  title: 'Withdraw',
  alert: {
    message: 'Please complete the KYC verification before withdrawing.',
    'button-text': 'Go to KYC',
  },
  'currency-type': {
    title: 'Receiving Currency',
  },
  form: {
    loginid: {
      label: 'Select Account',
      placeholder: 'Please select account',
      rule: {
        required: 'Please select account',
      },
      account_type: {
        wallet: 'Wallet Account',
        MT: 'MT Account',
        MT4: 'MT4',
        MT5: 'MT5',
      },
      account_detail: '{wallet_id}-{balance} {currency}',
    },
    password: {
      label: 'Fund Password',
      rule: {
        required: 'Please enter fund password',
      },
    },
  },
}
